import { useContentfulInspectorMode } from "@contentful/live-preview/react"
import { Row, Col } from "react-grid-system"
import styled from "styled-components"
import { ArrowButtonDown } from "../atoms/icons/ArrowButtonIcons"
import { Spacer, HorizontalSpacer } from "../atoms/spacers"
import H1 from "../atoms/typography/H1"
import H2 from "../atoms/typography/H2"
import H3 from "../atoms/typography/H3"
import { HeroSectionModel } from "./models"

const Container = styled.div<{ url?: string }>`
  background-color: grey;
  background-image: url("${({ url }) => url}");
  background-size: cover;
  background-repeat: no-repeat;
  background-position: 50% 50%;
  position: relative;
  aspect-ratio: 8 / 3;
  width: 100%;
  max-width: 100vw;
  max-height: 80vh;
  padding-top: 2rem;
  padding-bottom: 1rem;

  display: grid;
  justify-items: start;
  align-items: center;
  grid-template-rows: 1fr min-content;
  row-gap: 1rem;
`

const Content = styled.div``

const Bottom = styled.div`
  height: min-content;
  width: 100%;
  align-self: end;
`

const HeroSection: React.FC<Partial<HeroSectionModel>> = ({ sys, title, subtitle, image, showTitle = false }) => {
  const inspectorProps = useContentfulInspectorMode({ entryId: sys?.id })

  const onReadMore = () => {
    document.querySelector("#read-more")?.scrollIntoView({ behavior: "smooth", block: "start" })
  }

  return (
    <Container url={image?.url} {...inspectorProps({ fieldId: "image" })}>
      <Content>
        <Row justify="start">
          <Spacer spacing={5} />
          <Col xs={8}>
            {showTitle && (
              <H1 color="white" {...inspectorProps({ fieldId: "title" })}>
                {title}
              </H1>
            )}
            <HorizontalSpacer spacing={1} />
            {showTitle && (
              <H3 color="white" {...inspectorProps({ fieldId: "subtitle" })}>
                {subtitle}
              </H3>
            )}
          </Col>
        </Row>
      </Content>
      {showTitle && (
        <Bottom id="read-more">
          <Row justify="center" align="center">
            <Col
              xs="content"
              style={{ cursor: "pointer" }}
              tabIndex={0}
              onClick={() => onReadMore()}
              onKeyDown={(e) => e.key === "Enter" && onReadMore()}
            >
              <Row justify="center" align="center">
                <ArrowButtonDown color="white" />
                <Spacer spacing={1.5} />
                <H2 color="white">Read more</H2>
              </Row>
            </Col>
          </Row>
          <HorizontalSpacer spacing={1} />
        </Bottom>
      )}
    </Container>
  )
}

export default HeroSection
